import L from 'leaflet';
import MarkerIcon from "../images/map.svg"
import TreeIcon from "../images/tree.png"

  export const markerIcon = L.icon({
    iconUrl: MarkerIcon,
    iconSize: [30, 45],
    iconAnchor: [15, 54],
  });

  export const treeIcon = L.icon({
    iconUrl: TreeIcon,
    iconSize: [30, 45],
    iconAnchor: [15, 54],
  });

  
